import { createAction, props } from '@ngrx/store';

const ACTION_MAP_INFO = '[MAPS INFO]';

export const setPredictions = createAction(`${ACTION_MAP_INFO} Set predictions`, props<{ payload: any }>());

export const setIsLoading = createAction(`${ACTION_MAP_INFO} Set is loading`, props<{ payload: boolean }>());

export const setControlAddress = createAction(`${ACTION_MAP_INFO} Set control address`, props<{ payload: any }>());

export const cleanState = createAction(`${ACTION_MAP_INFO} Clean state`);

export const cleanPredictionsState = createAction(`${ACTION_MAP_INFO} Clean predictions state`);

export const setPreDictionSelected = createAction(
  `${ACTION_MAP_INFO} Set prediction selected`,
  props<{ value: string; data: any }>(),
);

export const clearPredictionSelected = createAction(`${ACTION_MAP_INFO} clearPrediction prediction selected`);

export const updateFormSelected = createAction(`${ACTION_MAP_INFO} Update form selected`, props<{ payload: any }>());

export const updateValidation = createAction(`${ACTION_MAP_INFO} Update validation`, props<{ value: boolean }>());

export const isCreatingPod = createAction(`${ACTION_MAP_INFO} Is creating POD`, props<{ payload: boolean }>());

export const hasAcceptedResetWarning = createAction(
  `${ACTION_MAP_INFO} Has accepted reset warning`,
  props<{ payload: boolean }>(),
);

export const ActionMapInfoTypes = {
  SetPredictions: setPredictions,
  SetIsLoading: setIsLoading,
  SetControlAddress: setControlAddress,
  CleanState: cleanState,
  CleanPredictionsState: cleanPredictionsState,
  SetPreDictionSelected: setPreDictionSelected,
  ClearPredictionSelected: clearPredictionSelected,
  UpdateFormSelected: updateFormSelected,
  UpdateValidation: updateValidation,
  IsCreatingPod: isCreatingPod,
  HasAcceptedResetWarning: hasAcceptedResetWarning,
};
